import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import server from './server'
import sidebar from './sidebar'
import courses from './courses'
import course from './course'
import mode_regime from './mode_regime'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    errorMain: null    
  },
  getters: {     
    errorMain(state) {
      return state.errorMain
    },
  },
  mutations: {  
    setErrorMain(state, error) {      
      state.errorMain = error;      
    },    
    clearErrorMain(state) {      
      state.errorMain = null;     
    },    
  },
  actions: {      
  },
  modules: {
    user, server, sidebar, courses, course, mode_regime
  }
})
